module.exports = __webpack_public_path__ + "static/media/ic_play_arrow_24px.d2d1436c.svg";